import { createServerFn } from "@tanstack/react-start"
import { listPublicGuides } from "@/lib/explore-data.server"
import type { guidesTable } from "@/db/schema"

// Client-safe surface for the explore SSR data: just the row type + the
// createServerFn wrapper. The db-touching read lives in `explore-data.server.ts`
// and is imported ONLY inside the handler below, so the compiler strips it from
// the client bundle (the same reason guide-meta.ts never leaks `db`/dotenv).

export type PublicGuideRow = Omit<
  typeof guidesTable.$inferSelect,
  `published_snapshot` | `description_rich`
>

// SSR data source for the /trips/explore guide grid. Same shape as the
// trpc.guides.listPublic query so the frontend can swap in a real <a href>
// server render. Runs during server render → direct Postgres (never a
// self-fetch to /api/trpc, which deadlocks in our deployment — see
// guide-meta.ts). Never throws: degrades to an empty grid on any DB error.
export const fetchExploreGuides = createServerFn({ method: `GET` }).handler(
  async (): Promise<PublicGuideRow[]> => {
    return listPublicGuides().catch(() => [])
  }
)
